import builder from '../builder';
import Attachment from '../../streamline-icons/bold/attachment.svg';

export default builder('IconAttachmentBold', Attachment);
